import React from 'react';

export default function Rating(props) {
  // round to the closest 0.5
  let num = Math.ceil(props.rating * 2) / 2;

  let rounded = Math.ceil(props.rating * 10) / 10;

  return (
    <span title={`Rating: ${rounded} of 5`}>
      {[0, 1, 2, 3, 4].map(v => {
        if (num <= v) {
          return <i key={v} className="fa fa-star-o" />;
        } else if (num <= v + .5) {
          return <i key={v} className="fa fa-star-half-o" />;
        } else {
          return <i key={v} className="fa fa-star" />;
        }
      })}
    </span>
  )
}


// WEBPACK FOOTER //
// ./src/Rating.js